export const nameChangeReasons = [
  {
    value: "marriage",
    label: "Marriage",
  },
  {
    value: "courtorder",
    label: "Court Order",
  },
];
